// Email sending (ADR 0049, docs/specs/email-marketing.md 2.4 and 2.20.8; story EM29): sending
// domains and their records, company addresses, who may send as them, Policies > Email marketing
// and the sending policy. The shared `SendingApi` (packages/api-client) over the console's
// session; every route is behind the company's `email_marketing`.

import { queryOptions } from "@tanstack/react-query";
import { type ApiClient, SendingApi, tenantHasEnt } from "@vd/api-client";
import { transport } from "./transport";
import type { Me } from "./types";

// `SendingApi` takes the client class; the console's transport has the same five methods
// (get, post, put, patch, del) over its own session.
export const sending = new SendingApi(transport as unknown as ApiClient);

export const sendingKeys = {
  all: ["admin", "sending"] as const,
  domains: ["admin", "sending", "domains"] as const,
  domain: (id: string) => ["admin", "sending", "domains", id] as const,
  addresses: ["admin", "sending", "addresses"] as const,
  settings: ["admin", "sending", "settings"] as const,
  policy: ["admin", "sending", "policy"] as const,
};

export const domainsQuery = queryOptions({
  queryKey: sendingKeys.domains,
  queryFn: ({ signal }) => sending.domains(signal),
});

export const domainQuery = (id: string) =>
  queryOptions({
    queryKey: sendingKeys.domain(id),
    queryFn: ({ signal }) => sending.domain(id, signal),
  });

export const addressesQuery = queryOptions({
  queryKey: sendingKeys.addresses,
  queryFn: ({ signal }) => sending.addresses(signal),
});

export const marketingSettingsQuery = queryOptions({
  queryKey: sendingKeys.settings,
  queryFn: ({ signal }) => sending.settings(signal),
});

export const sendingPolicyQuery = queryOptions({
  queryKey: sendingKeys.policy,
  queryFn: ({ signal }) => sending.policy(signal),
});

/** Whether the company holds email marketing on any seat: the console's sending pages and the
 * Integrations card show only then. A server older than plans sends no seat, which reads as yes,
 * as everywhere else (`tenantHasEnt`). */
export function companyHasEmailMarketing(me: Pick<Me, "seat"> | null | undefined): boolean {
  return tenantHasEnt(me ?? null, "email_marketing");
}
